import PageTileLink from "./AppTileLink";
import { SvgAppStore, SvgPlayStore } from "../SVG/svg";
import { useRef } from "react";
import AppForm from "./AppForm";
import IPhone from "./../../assets/appStore.png";

const AppTile = (props) => {
  const linkRef = useRef(null);

  const gotoPage = () => {
    if (props?.app_instances?.length === 1) {
      if (typeof props.app_instances[0].link === "string") {
        window.open(props.app_instances[0].link, "_blank");
      } else {
        linkRef.current.click();
      }
    }
  };

  const hasMultipleInstances = props?.app_instances?.length > 1;
  const hasStoreLinks =
    props?.mobile_app_links?.app_store ||
    props?.mobile_app_links?.app_store_iphone ||
    props?.mobile_app_links?.play_store;

  const renderStoreIcons = () => {
    return (
      <div
        className="app-store-box"
        onClick={(e) => e.stopPropagation()} 
      >
        <div style={{ padding: 3 }}>
          <strong>Download from</strong>
        </div>

        {props?.mobile_app_links?.app_store && (
          <a
            href={props.mobile_app_links.app_store}
            target="_blank"
            rel="noreferrer"
            onClick={(e) => e.stopPropagation()}
          >
            <SvgAppStore />
          </a>
        )}

        {props?.mobile_app_links?.app_store_iphone && (
          <a
            href={props.mobile_app_links.app_store_iphone}
            target="_blank"
            rel="noreferrer"
            onClick={(e) => e.stopPropagation()}
          >
            <img src={IPhone} alt="IPhone" style={{ height: "25px" }} />
          </a>
        )}

        {props?.mobile_app_links?.play_store && (
          <a
            href={props.mobile_app_links.play_store}
            target="_blank"
            rel="noreferrer"
            onClick={(e) => e.stopPropagation()}
          >
            <SvgPlayStore />
          </a>
        )}
      </div>
    );
  };

  return (
    <div className="card-tile" onClick={gotoPage}>
      {props?.app_instances?.length === 1 &&
        typeof props?.app_instances[0].link === "object" && (
          <AppForm
            app_instance={props?.app_instances[0]}
            setFormData={props.setFormData}
            linkRef={linkRef}
            isHidden={true}
          />
        )}

      <div className="card-tile-box">
        <div className="justify-content-between">
          <h3>{props.title}</h3>

          {props.addToFavorites ? (
            <div
              className="btn_disabled"
              onClick={(e) => {
                e.stopPropagation();
                props.addToFavorites(props.id);
              }}
            ></div>
          ) : (
            <div
              className="btn"
              onClick={(e) => {
                e.stopPropagation();
                props.removeFavorite(props.id);
              }}
            ></div>
          )}
        </div>

        <div
          className="relative"
          style={{ padding: 0, aspectRatio: 16 / 9, position: "relative" }}
        >
          <img
            src={props.image}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center",
            }}
            alt={props.title}
          />

          {hasMultipleInstances && (
            <div className="tile-dropdown-list">
              {hasMultipleInstances && (
                <ul>
                  {props.app_instances.map((list, index) => {
                    if (typeof list.link === "undefined") {
                      return <li key={index}>{list.title}</li>;
                    } else if (typeof list.link === "string") {
                      return (
                        <li key={index}>
                          <a href={list.link} target="_blank" rel="noreferrer">
                            {list.title}
                          </a>
                        </li>
                      );
                    } else {
                      return (
                        <li key={index}>
                          <AppForm
                            app_instance={list}
                            setFormData={props.setFormData}
                            linkRef={linkRef}
                          />
                        </li>
                      );
                    }
                  })}
                </ul>
              )}

              {hasStoreLinks && hasMultipleInstances && renderStoreIcons()}
            </div>
          )}
        </div>

        <div className="apptile-content">
          <div className="app-description" title={props.description}>
            {props.description}
          </div>

          <div
            className="pt-1"
            dangerouslySetInnerHTML={{ __html: props.description_footer }}
          />

          {!hasMultipleInstances && hasStoreLinks && renderStoreIcons()}
        </div>

        <PageTileLink showArrow={props?.app_instances?.length === 1} />
      </div>
    </div>
  );
};

export default AppTile;
